import React from "react";
import styled from "styled-components";
import { RoundedButton } from "./Buttons";
import ExpandIcon from "img/expand.svg";

const Button = styled(RoundedButton)`
  background-color: #203662;
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  text-wrap: nowrap;
  width: 147px;
  height: 32px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: none;
  padding: 0px 16px;
  &:hover {
    background-color: #1a2d52;
  }

  &:disabled {
    background-color: #e6e7e8;
    color: #a7a9ac;
    cursor: default;
  }

  &:focus {
    outline: none;
  }
`;

const IconContainer = styled.span`
  display: flex;
  align-items: center;
  width: 115px;
  font-size: 12px;
`;

const SvgIcon = styled.img`
  width: 10px;
  height: 6px;
  margin-left: 6px;
  transform: ${({ isExpanded }) =>
    !isExpanded ? "rotate(180deg)" : "rotate(0deg)"};
`;

const CreateMButton = ({
  title = "Create Module",
  icon,
  handleClick,
  disabled = false,
  minWidth,
  isExpanded,
}) => {
  return (
    <Button onClick={handleClick} disabled={disabled} minWidth={minWidth}>
      <IconContainer>
        {icon && <img src={icon} alt="" style={{ marginRight: "6px" }} />}
        {title}
        {isExpanded !== undefined && (
          <SvgIcon src={ExpandIcon} alt="expand" isExpanded={isExpanded} />
        )}
      </IconContainer>
    </Button>
  );
};

export default CreateMButton;
